module.exports = __webpack_public_path__ + "media/icons/no_check@2x-af28c01c.png";